const tableDesign = {
	color: {
		// primary: '#000000e0',
		primary: '#6c757d',
		secondary: '#1d232f',
	},
	background: {
		// primary: '#f6f5f5',
		primary: '#f8f9fa',
	},
	borderColor: {
		// primary: '#EdEdEd',
		primary: '#e9ecef',
	},
	borderRadius: {
		primary: '4px',
	},
	tableRowBackgroundColor: {
		// primary: '#F4F6F9',
		primary: '#fdfdfd',
	},
	headerFontSize: {
		primary: '12px',
	},
	headerFontWeight: {
		primary: 600,
	},
	fontSize: {
		primary: '12px',
	},
	fontWeight: {
		primary: 400,
	},
	padding: {
		primary: '6px 16px',
		secondary: '4px 16px',
		default: '0px 16px',
	},
};

export default tableDesign;
